import React, { useState } from 'react';
import { FiMessageCircle, FiX, FiSend } from 'react-icons/fi';
import './FloatingConsult.css';
import { addForm } from '../../api/gwform.js';
import { message } from 'antd';
const FloatingConsult = () => {
  const [isOpen, setIsOpen] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    remark: '',
    content: '',
    source: '识道造价',
  });
  const handleSubmit = async (e) => {
    e.preventDefault()
    // 这里可以添加表单提交逻辑
    await addForm(formData);
    message.success('感谢您的咨询，我们会尽快与您联系！')
    setFormData({ name: '', phone: '', remark: '', source: '识道造价', content: '' });
    setIsOpen(false);
  }

  return (
    <>
      <div className={`floating-consult-popup ${isOpen ? 'open' : ''}`}>
        <div className="popup-header">
          <h3>免费在线咨询</h3>
          <button className="popup-close" onClick={() => setIsOpen(false)}>
            <FiX />
          </button>
        </div>
        <div className="popup-body">
          <p className="popup-desc">提交需求，2 小时内专家顾问将与您联系</p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                placeholder="您的姓名 *"
                required
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />
            </div>
            <div className="form-group">
              <input
                type="tel"
                placeholder="联系电话 *"
                required
                value={formData.phone}
                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              />
            </div>
            <div className="form-group">
              <select
                required
                value={formData.type}
                onChange={(e) => setFormData({ ...formData, type: e.target.value })}
              >
                <option value="">请选择咨询类型 *</option>
                <option value="cost">全过程工程造价咨询</option>
                <option value="budget">概预算结算审核</option>
                <option value="tendering">招投标代理服务</option>
                <option value="platform">数智平台体验</option>
                <option value="other">其他咨询</option>
              </select>
            </div>
            <div className="form-group">
              <textarea
                placeholder="简要描述您的需求（选填）"
                rows="3"
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              />
            </div>
            <button type="submit" className="submit-btnc">
              <FiSend />
              <span>提交咨询</span>
            </button>
          </form>
        </div>
      </div>

      <button
        className={`floating-btn ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="在线咨询"
      >
        {isOpen ? <FiX /> : <FiMessageCircle />}
      </button>
    </>
  );
};

export default FloatingConsult;
